import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main className="pt-16 min-h-screen flex items-center justify-center px-4" data-testid="payment-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="max-w-lg w-full border border-white/10 bg-coal p-10 text-center"
      >
        <XCircle size={48} className="mx-auto text-blood mb-6" />
        <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-ash mb-3">[ Paiement annulé ]</p>
        <h1 className="font-syne font-extrabold uppercase tracking-tight text-3xl mb-4">Aucun débit.</h1>
        <p className="text-smoke text-sm mb-8">
          Votre paiement a été annulé. Votre panier est toujours là — il vous attend.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/boutique"
            data-testid="cancel-back-to-shop"
            className="bg-blood text-white font-mono text-xs uppercase tracking-[0.2em] px-8 py-4 hover:bg-white hover:text-ink transition-colors"
          >
            Retour à la boutique
          </Link>
        </div>
      </motion.div>
    </main>
  );
}
